import { createReducer, on } from '@ngrx/store';

import * as PlatformSettingsActions from './platform-settings.actions';
import { PlatformSettingsState } from './platform-settings.model';

export const featureKey = 'platform-settings';

const defaultEntryState = {
    loaded: false,
    loading: false,
    error: null
};

const platformSettingsInitialState: PlatformSettingsState = {
    paymentMethods: {
        ...defaultEntryState,
        data: []
    },
    common: {
        ...defaultEntryState,
        data: null
    }
};

export const reducer = createReducer(
    platformSettingsInitialState,
    on(PlatformSettingsActions.loadPaymentMethods, (state) => ({
        ...state,
        paymentMethods: {
            ...state.paymentMethods,
            loading: true,
            error: null
        }
    })),
    on(PlatformSettingsActions.loadPaymentMethodsSuccess, (state, { paymentMethods }) => ({
        ...state,
        paymentMethods: {
            ...state.paymentMethods,
            loading: false,
            loaded: true,
            data: paymentMethods
        }
    })),
    on(PlatformSettingsActions.loadPaymentMethodsFailure, (state, { error }) => ({
        ...state,
        paymentMethods: {
            ...state.paymentMethods,
            loading: false,
            error
        }
    })),
    on(PlatformSettingsActions.loadCommon, (state) => ({
        ...state,
        common: {
            ...state.common,
            loading: true,
            error: null
        }
    })),
    on(PlatformSettingsActions.loadCommonSuccess, (state, { common }) => ({
        ...state,
        common: {
            ...state.common,
            loading: false,
            loaded: true,
            data: common
        }
    })),
    on(PlatformSettingsActions.loadCommonFailure, (state, { error }) => ({
        ...state,
        common: {
            ...state.common,
            loading: false,
            error
        }
    })),
    on(PlatformSettingsActions.updatePaymentMethods, (state) => ({
        ...state,
        paymentMethods: {
            ...state.paymentMethods,
            loading: true,
            error: null
        }
    })),
    on(PlatformSettingsActions.updatePaymentMethodsSuccess, (state, { paymentMethods }) => ({
        ...state,
        paymentMethods: {
            ...state.paymentMethods,
            loading: false,
            data: paymentMethods
        }
    })),
    on(PlatformSettingsActions.updatePaymentMethodsFailure, (state, { error }) => ({
        ...state,
        paymentMethods: {
            ...state.paymentMethods,
            loading: false,
            error
        }
    })),
    on(PlatformSettingsActions.updateCommon, (state) => ({
        ...state,
        common: {
            ...state.common,
            loading: true,
            error: null
        }
    })),
    on(PlatformSettingsActions.updateCommonSuccess, (state, { commonSettings }) => ({
        ...state,
        common: {
            ...state.common,
            loading: false,
            data: commonSettings
        }
    })),
    on(PlatformSettingsActions.updateCommonFailure, (state, { error }) => ({
        ...state,
        common: {
            ...state.common,
            loading: false,
            error
        }
    }))
);
